import api from "./api";

export async function createBusiness(businessData) {

    const response = await api.post(
        "/api/v1/nextgo/business",
        businessData
    );

    return response.data;

}

export async function createOutlet(outletData) {

    const response = await api.post(
        "/api/v1/nextgo/outlet",
        outletData
    );

    return response.data;

}